import React from 'react'
import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'

function NoProducts() {
  return (
    <div>
      <Icon type={['fas', 'rocket']} color="grey" size="5x" />
      <p className="empty-content__text">
        You have no products on the marketplace.
        <br />
        Upload your models and start earning money today!
      </p>
      <a href="/profile/upload/model" className="btn btn-primary">Upload now!</a>
    </div>
  )
}

NoProducts.propTypes = {
}

export default NoProducts
